<template>
    <div>
        <app-snack
            v-for="(item, index) in items"
            :id="item.id"
            :key="item.id"
            :index="index"
            :alert-type="item.type"
            :multi-line="item.multiLine"
            :vertical="item.vertical"
            :timeout="item.timeout"
            :elevation="item.elevation"
            :retry="item.retry"
            :position="item.position"
            @remove="onRemoveSnack"
        >
            <template v-if="item.text" #text>
                <template v-if="Array.isArray(item.text)">
                    <div v-for="(textLine, textIndex) in item.text" :key="`text-${textIndex}`">
                        {{ textLine }}
                    </div>
                </template>
                <div v-else>{{ item.text }}</div>
            </template>
            <template #action="{ attrs }">
                <v-badge v-if="items.length > 1" outlined :content="items.length - 1" color="grey darken-3">
                    <app-button :text="$t('next')" v-bind="attrs" small @click="onRemoveSnack(item.id)" />
                </v-badge>
                <app-button
                    v-else
                    icon="close"
                    :color="'grey darken-2'"
                    v-bind="attrs"
                    small
                    @click="onRemoveSnack(item.id)"
                />
            </template>
        </app-snack>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppSnackQueue',
    components: {
        AppSnack: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppSnack'
            )
    },
    computed: {
        ...mapGetters('snackQueue', ['items', 'processing'])
    },
    methods: {
        onRemoveSnack(id) {
            this.$store.dispatch('snackQueue/remove', id);
        }
    }
};
</script>
